import './Client.scss';

import { Button } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// import { useForm } from 'react-hook-form';
//import { Form } from 'react-bootstrap';
//import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';

import { Svg1Step22 } from '../../../data/SVGs';
import useWindowSize from '../../../hooks/useWindowSize';
import SideBarMobile from '../../Expert/CompleterProfile/SideBarMobile';
import DrawSideBar from './SideBarClient';
import ComapyExists from './Step3_companyData/ComapyExists';
import NewCompany from './Step3_companyData/NewCompany';
const ClientStep3 = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    useEffect(() => {
        if(state?.newCompany === false || state?.newCompany === true)
        {
            console.log('we are good to go');
        }
        else{
            navigate('/client', {});
        }
    }, [state]);

    return (
        <>
            <div style={{ display: 'flex', flexDirection: device=='desktop'?'row':'column', alignSelf: 'stretch' }}>
                {device=='desktop' &&
                <DrawSideBar />
                }
                {device!='desktop' &&
                    <SideBarMobile
                        etape={'Etape 2'}
                        etapSuivante='Etape 3'
                        number='2'
                    />
                }
                {(() => {
                    if (state?.newCompany === true) {
                        return (
                            <>
                                <div style={{ display: 'flex', width: device=='desktop'?'80%':'100%', justifyContent: 'center', padding:device=='desktop'?'0px':'16px',paddingTop: '64px' }}>
                                    <NewCompany action={'create'} />
                                </div>
                                {device=='desktop' &&
                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <Svg1Step22 />
                                </div>
                                }
                            </>
                        );
                    } else if (state?.newCompany === false) {
                        return (
                            <ComapyExists isNewCompany={false} />
                        );
                    }
                    //TODO : redirection vers home
                    else {
                        return (
                            <>
                                <h3>{i18n.t('Désolé, quelque chose ne s\'est pas déroulé comme prévu. Veuillez retourner à l\'étape 2 et réessayer.')}</h3>
                                <Button onClick={() => navigate('/client', {})}>
                                    {i18n.t('Accueil')}
                                </Button>
                            </>
                        );
                    }
                })()}
            </div>
        </>
    );
};

export default ClientStep3;
